import {jsx} from 'panel';

import {TooltipEl} from 'common/components/tooltip';
import {SvgIconEl} from 'common/components/svg-icon';
import {Placement} from 'common/components/tooltip/types';
import {getReportNameFromSearchContext, getSearchIconFromDisplayContext} from 'common/report/util/search';
import {SearchDisplayContext, SearchDisplayContextDisplayName} from 'common/report/util/search/types';
import {findKeyByValue} from 'common/util/typescript';
import {RowEntity} from 'common/widgets/entity-collection/entity-table/types';
import {getDashboardAllowedReports} from 'common/report/util/boards';

function getEntitySublabel(entity: RowEntity) {
  const report = getReportNameFromSearchContext(entity.displayContext);
  const isDashboardAllowedReport = getDashboardAllowedReports().includes(report);
  return isDashboardAllowedReport ? entity.dashboard : ``;
}

export const CellEntityNameWithIcon = ({
  entity,
  skipEntityLinks,
  skipEntityIcon,
}: {
  entity: RowEntity;
  skipEntityLinks: boolean;
  skipEntityIcon?: boolean;
}) => {
  const entityIcon = skipEntityIcon ? null : getSearchIconFromDisplayContext(entity.displayContext);
  const entityDisplayType =
    SearchDisplayContextDisplayName[findKeyByValue(SearchDisplayContext, entity.displayContext)];
  const entitySubLabel = getEntitySublabel(entity);

  return (
    <div sel='.cell-entity-name'>
      {entityIcon ? (
        <div sel='.cell-entity-icon'>
          <SvgIconEl
            attrs={{
              icon: entityIcon,
            }}
          />
          <TooltipEl attrs={{placement: Placement.Right}}>{entityDisplayType}</TooltipEl>
        </div>
      ) : null}
      <div sel='.cell-entity-title'>
        <a sel='.entity-link' attrs={{...(skipEntityLinks ? {} : {href: entity.link})}}>
          {entity.name}
        </a>
        {entitySubLabel ? <div sel='.cell-entity-description'>{entitySubLabel}</div> : null}
      </div>
    </div>
  );
};
